import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { Actions } from "./Actions";
import { ThemeProviderContext } from "../../ThemeProvider";
export const ButtonField = (props) => {
    return (_jsx(ThemeProviderContext.Consumer, { children: ({ translate }) => {
            var _a, _b;
            return (_jsx("button", Object.assign({}, props.getReferenceProps({
                type: "button",
                onBlur: props.onBlur,
                className: classNames("text-left outline-none block w-full", props.isDisabled && "cursor-default"),
                disabled: props.isDisabled,
                ref: props.triggerRef,
                role: "button",
                id: props.id,
            }), { children: _jsx("div", { className: "relative w-full", children: _jsxs("div", { className: "flex", children: [_jsx("div", { className: "flex-1 text-ellipsis overflow-hidden whitespace-nowrap mr-1", children: (_b = (props.value && ((_a = props.value) === null || _a === void 0 ? void 0 : _a.label))) !== null && _b !== void 0 ? _b : (props.placeholder || translate("select.select")) }), _jsx(Actions, Object.assign({}, props, { isEmptyValue: !props.value }))] }) }) })));
        } }));
};
//# sourceMappingURL=ButtonField.js.map